module.exports = __webpack_public_path__ + "img/logo-hutil.f0b6fbab.png";